module.exports = veComponentsMfeConfig;